import React from 'react'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { ChevronRightIcon } from '@heroicons/react/24/outline'

import Logo from '../Logo'

import SustainLogoImage from './sustainLogo.png'
import CarbonLogoImage from './carbonLogo.png'
import PpaLogoImage from './ppaLogo.png'
import CrmLogoImage from './crmLogo.png'

const productLogos: Record<string, string> = {
  sustain: SustainLogoImage,
  carbon: CarbonLogoImage,
  ppa: PpaLogoImage,
  crm: CrmLogoImage,
}

interface ProductSwitcherProps {
  currentUser: {
    allowed_applications?: string[]
  }
  currentProduct: string
  climateApps: Record<string, string>
}

const ProductSwitcher = ({ currentUser, currentProduct, climateApps }: ProductSwitcherProps) => {
  const allowedApplications = Object.entries(climateApps)
    .filter(([productName]) => productName !== currentProduct)
    .filter(([productName]) => currentUser?.allowed_applications?.includes(productName))

  const hasAllowedApplications = allowedApplications.length > 0

  return (
    <>
      {currentProduct && (
        <Menu as="div" className="relative">
          {({ open }) => {
            return (
              <>
                <div data-cy="product-switcher">
                  <MenuButton className="flex items-center">
                    <Logo LogoImage={productLogos[currentProduct]}
                      alt={`Tellus ${currentProduct.toUpperCase()} logo`} />
                    {hasAllowedApplications && <ChevronRightIcon className={`rotate-90 transform w-4 text-gray-400 ml-2`} />}
                  </MenuButton>
                </div>

                {hasAllowedApplications && <Transition
                  show={open}
                  enter="transition ease-out duration-200"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <MenuItems
                    static
                    className="px-2 space-y-2 pt-4 pb-2 z-50 origin-top-left absolute left-1/2 transform -translate-x-1/2 w-60 rounded-md shadow-xl bg-perfect-shine-dark focus:outline-hidden shadow-bonfire-dark-dark"
                  >
                    {allowedApplications.map(([productName, productUrl]) => (
                      <MenuItem key={productName}>
                        <div className="hover:bg-pacific-storm p-2 rounded-md transition-colors duration-200">
                          <a href={productUrl}>
                            <Logo LogoImage={productLogos[productName]}
                              alt={`Tellus ${currentProduct.toUpperCase()} logo`}
                              classes="" />
                          </a>
                        </div>
                      </MenuItem>
                    ))}
                  </MenuItems>
                </Transition>}
              </>
            )
          }}
        </Menu>
      )}
    </>
  )
}

export default ProductSwitcher
